
import { AdminTenantProvider } from 'app/contexts/adminTenant/Provider';
import { AuthProvider } from 'app/contexts/auth/Provider';
import { BreakpointProvider } from 'app/contexts/breakpoint/Provider';
import { LocaleProvider } from 'app/contexts/locale/Provider';
import { SidebarProvider } from 'app/contexts/sidebar/Provider';
import { ThemeProvider } from 'app/contexts/theme/Provider';
import { ClientThemeProvider } from 'contexts/ThemeContext';
import { MapProvider } from 'app/contexts/MapContext';
import { RouterProvider } from 'react-router';
import { routerAdmin, routerIndustrial, routerManager, routerMonitoring } from 'app/router';
import { useAppModule } from 'hooks/useAppModule';

const ROUTERS = {
  ADMIN: routerAdmin,
  INDUSTRIAL: routerIndustrial,
  MONITORING: routerMonitoring,
  MANAGER: routerManager,
};

function App() {
  const { module } = useAppModule();

  const router = ROUTERS[module] || routerIndustrial;

  return (
    <ClientThemeProvider>
      <AuthProvider>
        <AdminTenantProvider>
          <ThemeProvider>
            <LocaleProvider>
              <BreakpointProvider>
                <SidebarProvider>
                  <MapProvider>
                    <RouterProvider router={router} />
                  </MapProvider>
                </SidebarProvider>
              </BreakpointProvider>
            </LocaleProvider>
          </ThemeProvider>
        </AdminTenantProvider>
      </AuthProvider>
    </ClientThemeProvider>
  );
}

export default App;
